module.exports = __webpack_public_path__ + "img/arrow_drawn2.2ae0e57e.svg";